import { useRouter } from "next/router";
import { useState } from "react";
import cloneDeep from "lodash/cloneDeep";

const useQueryParamsState = (key, defaultValue) => {
  const router = useRouter();
  const [storedState, setStoredState] = useState(
    router.query[key] ?? defaultValue ?? null,
  );
  const queryCopy = cloneDeep(router.query);

  const setState = (value) => {
    if (value === "") {
      delete queryCopy[key];
    } else {
      queryCopy[key] = value;
    }
    setStoredState(value);
    router.replace(
      {
        pathname: router.pathname,
        query: { ...queryCopy },
      },
      undefined,
      { shallow: true },
    );
  };

  return [storedState, setState];
};

export default useQueryParamsState;
